import { DatePipe } from '@angular/common';
import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { ListPagerComponent } from '../../components/list-pager/list-pager.component';
import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RestService from '../../services/core-rest.service';
import ChatService from '../../services/chat.service';
import ChatRestServices from '../../services/chat-rest.service';
import Session from '../../utils/session.service';
import DialogServices from '../../services/dialog.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import { Input } from '@angular/core';
import { ModalPreVisitTicketInfoComponent } from '../modal-pre-visit-ticket-info/modal-pre-visit-ticket-info.component';
import { ModalSymptomCheckInfoComponent } from '../modal-symptom-check-info/modal-symptom-check-info.component';

@Component({
	standalone: true,
	selector: 'service-provider-pre-visit-history',
	templateUrl: './service-provider-pre-visit-history.component.html',
	imports: [
		CommonModule, DatePipe, ArrayLimitToPipe, StartFromPipe, 
		TranslatePipe, LoaderOverlayComponent, ListPagerComponent, FormsModule
	]
})
export class ServiceProviderPreVisitHistoryComponent implements OnInit, OnDestroy {
	private restService: RestService = inject(RestService);
	private chatService: ChatService = inject(ChatService);
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private session: Session = inject(Session);
	private dialogServices: DialogServices = inject(DialogServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	
	@Input() tabs: any;
	@Input() nameFilter: any | undefined;
	@Input() activeTab: any | undefined;
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.loading = true;
		this.vm.user = this.session.getSession().user;
		this.vm.isDoctor = this.vm.user.businessUserType === 'SERVICE_PROVIDER';
		this.vm.preVisitTickets = null;
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = this.vm.currentPage || 0;
		this.vm.endReached = false;
		this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
		this.loadPreVisits(true);
		
		var currentPage = this.vm.currentPage;
		var currentNameFilter = this.vm.nameFilter;
		this.watcher = this.angularHelperService.createInterval(() => {
			if (this.vm.currentPage !== currentPage) {
				currentPage = this.vm.currentPage;
				if (currentPage) {
					this.loadPreVisits();
				}
			}
			
			if (this.vm.nameFilter !== currentNameFilter) {
				currentNameFilter = this.vm.nameFilter;
				currentPage = 0;
				this.vm.currentPage = 0;
				this.loadPreVisits(true);
			}
		}, 300);
		
		this.vm.enumTranslations = {
			'NEW_HEALTH_PROBLEM': this.angularFilterHelperService.translate('PreVisit.User_Tickets.NEW_HEALTH_PROBLEM'),
			'PRESCRIPTION_RENEW_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.PRESCRIPTION_RENEW_REQUEST'),
			'HEALTH_CERTIFICATE_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.HEALTH_CERTIFICATE_REQUEST'),
			'HEALTH_CHECKUP_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.HEALTH_CHECKUP_REQUEST'),
			'VACCINATION_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.VACCINATION_REQUEST'),
			'NEW_PRESCRIPTION_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.NEW_PRESCRIPTION_REQUEST'),
			'CHILD_RELATED_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CHILD_RELATED_REQUEST'),
			'CHRONICALLY_ILL_VISIT_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CHRONICALLY_ILL_VISIT_REQUEST'),
			'SICK_LEAVE_CERTIFICATE_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.SICK_LEAVE_CERTIFICATE_REQUEST'),
			'FOLLOW_UP_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.FOLLOW_UP_REQUEST'),
			'CHRONICALLY_ILL_PRESCRIPTION_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CHRONICALLY_ILL_PRESCRIPTION_REQUEST'),
			'REFERRAL_LETTER_TO_PSYCHOLOGIST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.REFERRAL_LETTER_TO_PSYCHOLOGIST'),
			'MENTAL_HEALTH_CONSULTATION_REPORT': this.angularFilterHelperService.translate('PreVisit.User_Tickets.MENTAL_HEALTH_CONSULTATION_REPORT'),
			'CREATED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CREATED'),
			'SENT': this.angularFilterHelperService.translate('PreVisit.User_Tickets.SENT'),
			'REFERRED_PRACTICE': this.angularFilterHelperService.translate('PreVisit.User_Tickets.SENT'),
			'PARTNER_SYSTEM_CONFIRMED_RECEIVED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.SENT'),
			'REQUIRES_REGISTRATION': this.angularFilterHelperService.translate('PreVisit.User_Tickets.REQUIRES_REGISTRATION'),
			'BOOKED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.BOOKED'),
			'COMPLETED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.COMPLETED'),
			'CANCELED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CANCELED'),
			'CANCELED_ERROR': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CANCELED'),
			'CANCELED_SENT': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CANCELED'),
			'CANCELED_CONFIRMED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CANCELED'),
			'REJECTED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.REJECTED'),
			'MEDIPOST_SEND_ERROR': this.angularFilterHelperService.translate('PreVisit.User_Tickets.ERROR'),
			'INTERNAL_ERROR': this.angularFilterHelperService.translate('PreVisit.User_Tickets.ERROR'),
			'PARTNER_SYSTEM_PROCESSING_FAILED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.ERROR'),
			'PARTNER_SYSTEM_TRANSIENT_ERROR': this.angularFilterHelperService.translate('PreVisit.User_Tickets.ERROR')
		};
		
		this.vm.openSymptomCheckInfo = this.openSymptomCheckInfo;
		this.vm.openTicketInfo = this.openTicketInfo;
		this.vm.openChat = this.openChat;
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	openChat(ticket) {
		if (this.vm.isDoctor) {
			if (!ticket || ticket && !ticket.patient) return;
		} else {
			return;
		}
		this.chatRestServices.getChatByFriendId({ friendUserId: ticket.patient.id },
			(chat) => {
				this.chatService.openChatById(ticket.patient, chat.id);
			}
		);
	}
	
	openTicketInfo(ticket) {
		if (!ticket || !this.vm.isDoctor) return;
		this.dialogServices.show({
			controller: ModalPreVisitTicketInfoComponent,
			ticket: ticket
		});
	}
	
	openSymptomCheckInfo(ticketId) {
		if (!ticketId) return;
		this.dialogServices.show({
			controller: ModalSymptomCheckInfoComponent,
			interviewId: undefined,
			preVisitTicketId: ticketId
		});
	}
	
	loadPreVisits(isInitial?) {
		if (isInitial) {
			this.vm.endReached = false;
		} else if (this.vm.endReached) {
			this.vm.loading = false;
			return;
		}
		var filterParams = {
			pageSize: this.vm.pageSize * 2,
			start: (!isInitial && this.vm.preVisitTickets) ? this.vm.preVisitTickets.length : 0
		};
		if (this.vm.nameFilter) {
			filterParams['name'] = this.vm.nameFilter;
		}
		this.restService.getServiceProviderPreVisitTickets(filterParams)
			.then((response) => {
				if (response && response.length < this.vm.pageSize * 2) {
					this.vm.endReached = true;
				}
				this.vm.preVisitTickets = isInitial ? response : this.vm.preVisitTickets.concat(response);
				this.vm.preVisitTickets.map((ticket) => {
					ticket.closeInfo = () => {
						ticket.isOpen = false;
					};
				});
				for (var index in this.vm.preVisitTickets) {
					var ticket: any = this.vm.preVisitTickets[index];
					if (ticket.type === 'NEW_HEALTH_PROBLEM' && ticket.ticketDataList && ticket.ticketDataList.length > 0
						&& ticket.ticketDataList[0].config.fieldName === 'INFERMEDICA_INTERVIEW_ID') {
						ticket.infermedicaInterviewId = ticket.ticketDataList[0].content;
					}
				}
				this.vm.loading = false;
			}).catch((error) => {
				this.vm.loading = false;
				console.log(error);
			});
	}
	
}